<!-- HEADING PART -->
<p-card>
  <div class="grid">

    <div class="col-12 md:col-12 lg:col-12 breadcrumbrightmenu">
      <div class="text-end p-0 border-round-sm font-bold">
        <p-button *ngIf="hasLimitedAccess == 'N'"  (click)="show('Add ' + verticalLabelName, '')" styleClass="customAdd p-button-sm p-button-raised mr-4"
          icon="fa fa-plus" pTooltip="Add {{verticalLabelName}}" tooltipPosition="left"></p-button>
        <button class="fa fa-question helpicon" pTooltip="Help"
          (click)="PagehelpmodalService.openhelpmodal(ref,dialogService,'Help','3')" tooltipPosition="bottom"
          aria-hidden="true"></button>
      </div>

    </div>

  </div>

  <div>
    <p-table #dt [value]="tableData" [rows]="rowsize" [scrollable]="true" scrollDirection="horizontal" [customSort]="true"
      (sortFunction)="this.utilityservice.customSort($event)" scrollHeight="{{commonScrollHeight}}"
      [globalFilterFields]="searchcolumns"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      (onPage)="handlePageChange($event)" [rowsPerPageOptions]="paginatorArray" dataKey="id" [rowHover]="true"
      [showCurrentPageReport]="true" [sortField]="sortfield" [sortOrder]="sortorder" paginatorLocale="fa-IR"
      [paginator]="tableData.length>0" responsiveLayout="scroll" [resizableColumns]="true" columnResizeMode="expand"
      [first]="currentPageIndex"
      >
      <!-- search -->

      <ng-template pTemplate="caption">
        <div class="grid table-header">
          <div class="col-12 md:col-10 sm:col-12 lg:col-10">
            <span class=" p-input-icon-lft">
              <i icon="pi pi-search"></i>
              <input class="form-control" pInputText type="text" id="tablesearch"
                (input)="dt.filterGlobal($any($event.target).value , 'contains'); searchTerm = $any($event.target).value;"
                placeholder="Search in {{verticalLabelName}}" class="tablesearch" pTooltip="Enter Search Criteria"
                tooltipPosition="top" />
            </span>
          </div>
          <div class="col-12 lg:col-2 md:col-2 sm:col-12 ">
            <div class="iconexcel" pTooltip="Download Data" tooltipPosition="bottom" (click)="showDialog()"></div>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 5px !important;" class="tableaction">Action</th>
          <ng-container *ngFor="let col of _selectedColumns">
            <th [pSortableColumn]="col.field" *ngIf="col.isChecked" pResizableColumn>
              {{col.header}}<p-sortIcon [field]="col.field"></p-sortIcon>
              <p-columnFilter type="text" [field]="col.field" *ngIf="col.filter" display="menu"></p-columnFilter>
            </th>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data>
        <tr>
          <!-- <td>
            <span class="actionItm" pTooltip="Modify" tooltipPosition="left"> <i class="fa fa-edit"
                (click)="show('Modify Vertical',data)"></i></span>
            <span *ngIf="this.isSupportAdmin=='Y'"  class="actionItm" pTooltip="Inactive '{{verticalLabelName}}" tooltipPosition="left"> <i class='fa fa-times'
              style='color:red'
                (click)="openInactiveModal(data)"></i></span>
          </td> -->
          <td style="width: 5px !important;">
             <div style="display: flex; gap: 0px;">
            <span class="actionItm" pTooltip="Modify" tooltipPosition="left">
              <i class="fa fa-edit" (click)="show('Modify Vertical', data)"></i>
            </span>

            <span *ngIf="this.isSupportAdmin=='Y' && data.activeflag=='Y'" class="actionItm icon-gap"
              pTooltip="Inactivate {{verticalLabelName}}" tooltipPosition="left">
              <i class="fa fa-times" style="color:red" (click)="openInactiveModal(data)"></i>
            </span>
            </div>
          </td>

          <ng-container *ngFor="let col of _selectedColumns">
            <td *ngIf="col.isChecked" [style.width]="col.width" [class]="col.class">
              <span *ngIf="col.field !== 'activeflag'" pTooltip=" {{data[col.field]}}"
                [innerHTML]="highlight(data[col.field],searchTerm)"></span>
              <span *ngIf="col.field=='activeflag'">
                <i *ngIf="data[col.field]=== 'Y'" pTooltip="Active" tooltipPosition="left" class="fa fa-flag"
                  aria-hidden="true" style="color: green;"></i>
                <i *ngIf="data[col.field]!== 'Y'" pTooltip="Inactive" tooltipPosition="left" class="fa fa-flag"
                  aria-hidden="true" style="color: red;"></i>
              </span>
            </td>
            <!-- <td *ngIf="col.isChecked" [style.width]="col.width" [class]="col.class">
              <span *ngIf="col.field!=='activeflag'" pTooltip=" {{data[col.field] }}">{{data[col.field]}}</span>
              <span *ngIf="col.field=='activeflag'">
                <i *ngIf="data[col.field]=== 'Y'" pTooltip="Active" tooltipPosition="left" class="fa fa-flag"
                  aria-hidden="true" style="color: green;"></i>
                <i *ngIf="data[col.field]!== 'Y'" pTooltip="Inactive" tooltipPosition="left" class="fa fa-flag"
                  aria-hidden="true" style="color: red;"></i>
              </span>
            </td> -->
          </ng-container>
        </tr>
      </ng-template>
       <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" class="datanotfound">
            No data available
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-card>

<p-dialog [header]="'Inactivate ' + verticalLabelName" [(visible)]="inactiveModal" [modal]="true" [baseZIndex]="10000"
  [draggable]="true" [resizable]="false" position="center" [style]="{width: 'auto%', height: 'auto'}">

  <div class="p-3">
    <p *ngIf="selectedVerticalName">
      The <strong>{{ selectedVerticalName }}</strong> {{verticalLabelName}} will be inactivated upon clicking the <b>Inactivate</b> button.!
    </p>
  </div>

  <div class="custom-dialog-footer">
    <p-button class="m-1 w-full" label="Close" styleClass="customeclose" (click)="inactiveModal=false"></p-button>
    <p-button class="m-1 w-full" label="Inactivate" styleClass="customesave"
      (click)="inactivateVertical(verticalId)"></p-button>
  </div>
</p-dialog>